import { render, staticRenderFns } from "./NewsletterPage.vue?vue&type=template&id=8331ebf6&scoped=true&"
import script from "./NewsletterPage.vue?vue&type=script&lang=js&"
export * from "./NewsletterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8331ebf6",
  null
  
)

export default component.exports